import update from 'immutability-helper';
import {
  API_TREASURE_FETCH,
  API_TREASURE_FETCH_SUCCESS,
  API_TREASURE_REDEEM_SUCCESS,
  API_TREASURE_REDEEM_CLEAN,
  API_TREASURE_REDEEM_REQUEST,
  AUTH_LOGOUT,
} from '../actions/types';
import {createReducer} from '../utils';
import {
  LIST_PAGE_SIZE,
} from '../configs/constants';

const initialState = {
  isTreasureListFetching: false,
  isTreasureRedeeming: false,
  redeemSuccess: false,
  list: [],
  page: 1,
  hasMore: true,
  currentPlayer: {},
};

const treasureReducer = createReducer(initialState, {
  [API_TREASURE_FETCH]: (state, payload) => {
    const {page} = payload;
    return update(state, {
      isTreasureListFetching: {$set: true},
      page: {$set: page},
    });
  },
  [API_TREASURE_FETCH_SUCCESS]: (state, payload) => {
    const {page} = state;
    const {response: {list: loadedList, count, availablePoints}} = payload;
    const hasMore = (LIST_PAGE_SIZE * page) < count;
    const setter = (page === 1) ? '$set' : '$push';

    return update(state, {
      isTreasureListFetching: {$set: false},
      list: {[setter]: loadedList},
      hasMore: {$set: hasMore},
      page: {$set: page + 1},
      availablePoints: {$set: availablePoints},
    });
  },
  [API_TREASURE_REDEEM_REQUEST]: state => update(state, {
    isTreasureRedeeming: {$set: true},
  }),
  [API_TREASURE_REDEEM_SUCCESS]: (state, {response: {availablePoints}}) => update(state, {
    isTreasureRedeeming: {$set: false},
    redeemSuccess: {$set: true},
    availablePoints: {$set: availablePoints},
  }),
  [API_TREASURE_REDEEM_CLEAN]: state => update(state, {
    redeemSuccess: {$set: false},
  }),
  [AUTH_LOGOUT]: () => initialState,
});

export default treasureReducer;
